module.exports = __webpack_public_path__ + "assets/b39.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b39.png
// module id = 626
// module chunks = 0